import { c as _c } from "react/compiler-runtime";
import React from 'react';
import NotificationItem from './NotificationItem';
import { useRouter } from 'next/navigation';
import { useDispatch, useSelector } from "react-redux";
import { removeNotification } from "../../../Redux/slice/notificationSlice";
function NotificationList(t0) {
  const $ = _c(14);
  const {
    notificationData,
    type,
    setNotification
  } = t0;
  const users = useSelector(_temp);
  const route = useRouter();
  const dispatch = useDispatch();
  let t1;
  if ($[0] !== dispatch || $[1] !== route || $[2] !== setNotification || $[3] !== users?.type) {
    t1 = notification => {
      const messageId = notification?.metadata?.messageId;
      if (messageId && /^[a-f\d]{24}$/i.test(messageId)) {
        const path = users?.type === "reps" ? "/reps/messages" : "/provider/message";
        route.push(`${path}?userId=${notification.senderId}&messageId=${messageId}`);
        setNotification(false);
        dispatch({
          type: "notifications/markAsRead",
          payload: {
            notificationIds: [notification?._id]
          }
        });
        return;
      }
      if (users?.type !== "reps") {
        route.push(`/provider/message?userId=${notification?.senderId}${notification?.appointmentId ? "&messageId=" + (typeof notification?.appointmentId === "string" ? notification?.appointmentId : notification?.appointmentId?._id) : ""}`);
      }
      if (users?.type === "reps") {
        route.push(`/reps/messages?userId=${notification?.senderId}${notification?.appointmentId ? "&messageId=" + (typeof notification?.appointmentId === "string" ? notification?.appointmentId : notification?.appointmentId?._id) : ""}`);
      }
      setNotification(false);
      dispatch({
        type: "notifications/markAsRead",
        payload: {
          notificationIds: [notification?._id]
        }
      });
      if (notification?.appointmentId) {
        dispatch(removeNotification({
          notificationId: notification?._id,
          type: "meeting"
        }));
      }
    };
    $[0] = dispatch;
    $[1] = route;
    $[2] = setNotification;
    $[3] = users?.type;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleNotificationClick = t1;
  let t2;
  if ($[5] !== handleNotificationClick || $[6] !== notificationData || $[7] !== type) {
    let t3;
    if ($[9] !== handleNotificationClick || $[10] !== type) {
      t3 = (notification_0, index) => notification_0?.type && (type === notification_0?.type || type === "all") ? <NotificationItem onClick={handleNotificationClick} key={index} notification={notification_0} /> : "";
      $[9] = handleNotificationClick;
      $[10] = type;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    t2 = notificationData.map(t3);
    $[5] = handleNotificationClick;
    $[6] = notificationData;
    $[7] = type;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[12] !== t2) {
    t3 = <section className="flex flex-wrap cursor-pointer gap-2 sm:gap-4 overflow-y-auto no-scrollbar max-h-[300px] sm:max-h-[400px] self-center mt-2 w-full"><div className="flex flex-col font-poppins w-full">{t2}</div></section>;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}
function _temp(state) {
  return state?.userData?.userData?.user;
}
export default NotificationList;